
import { defineComponent, SetupContext } from '@vue/composition-api';
import useNoToursInStatic from './useNoToursInStatic';

export default defineComponent({
    name: 'NoToursInStaticBanner',
    setup(_props, ctx: SetupContext) {
        return useNoToursInStatic(ctx);
    },
});
